// src/config/pricing.ts
export type Sku = "time60" | "time120" | "time300" | "hint1" | "hint3" | "hint5";

export const PRICES: Record<
  Sku,
  {
    stars: number;           // Telegram Stars price
    title: string;           // UI label
    grant: { type: "time" | "hint"; amount: number }; // what to credit on success
  }
> = {
  time60:  { stars: 10,  title: "+60s",   grant: { type: "time", amount: 60 } },
  time120: { stars: 18,  title: "+120s",  grant: { type: "time", amount: 120 } },
  time300: { stars: 40,  title: "+300s",  grant: { type: "time", amount: 300 } },
  hint1:   { stars: 12,  title: "1 Hint", grant: { type: "hint", amount: 1 } },
  hint3:   { stars: 30,  title: "3 Hints",grant: { type: "hint", amount: 3 } },
  hint5:   { stars: 45,  title: "5 Hints",grant: { type: "hint", amount: 5 } },
};
